import Mock from 'mockjs'
import { save } from '@/mock/util'
import { dataItems } from '@/mock/net-sec/data'

const {page} = require('../util');

const qs = require('qs');
const {logList, sendDataDetail} = require('./data');

Mock.mock('/datalog/list', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = page(logList, bodyObject);
    bodyObject.total = logList.length;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/datalog/detail', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = page(sendDataDetail, bodyObject);
    bodyObject.total = sendDataDetail.length;
    return {
        code: 200,
        body: bodyObject,
    }
});

